import React, { useState } from 'react';
import RunbookStep from './RunbookStep';
import ConfirmDialog from './ConfirmDialog';
import './RunbookSection.css';

function RunbookSection({ steps, activeStepId, setActiveStepId, completedSteps, onStepComplete, onTimeUpdate }) {
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    message: '',
    step: null
  });
  // Start from a specific step
  const handleStartFromStep = () => {
    // Determine starting step
    let startingStep = activeStepId;
    if (!startingStep) {
      // Find first expanded step or default to first step
      const firstExpandedStep = steps.find(step => document.querySelector(`.step-item[data-step="${step.id}"].active`));
      startingStep = firstExpandedStep ? firstExpandedStep.id : 1;
    }
    
    // Open confirmation dialog
    setConfirmDialog({
      isOpen: true,
      message: `Start timer sequence from Step ${startingStep}: ${steps[startingStep-1].name}?`,
      step: startingStep
    });
  };
  
  // Handle confirmation dialog result
  const handleConfirm = () => {
    const startingStep = confirmDialog.step;
    
    // Mark all previous steps as completed
    for (let i = 1; i < startingStep; i++) {
      if (!completedSteps.includes(i)) {
        onStepComplete(i);
      }
    }
    
    // Set active step
    setActiveStepId(startingStep);
    
    // Close the dialog
    setConfirmDialog({...confirmDialog, isOpen: false});
  };
  
  const handleCancel = () => {
    // Close the dialog without action
    setConfirmDialog({...confirmDialog, isOpen: false});
  };

  return (
    <section className="runbook-section">
      <h2>Interactive Runbook</h2>
      <div className="runbook-controls">
        <button 
          onClick={handleStartFromStep}
          className="start-all-button"
        >
          Start from this step
        </button>
      </div>
      
      <div className="steps-container">
        {steps.map(step => (
          <RunbookStep 
            key={step.id}
            step={step}
            isActive={activeStepId === step.id}
            isCompleted={completedSteps.includes(step.id)}
            onStepComplete={onStepComplete}
            setActiveStepId={setActiveStepId}
            onTimeUpdate={onTimeUpdate}
          />
        ))}
      </div>
      
      {/* Confirmation Dialog */}
      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        message={confirmDialog.message}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </section>
  );
}

export default RunbookSection;